import React from "react";
import _ from "lodash";

const InspectionResultWithUnit = ({ inspectionResult, unit, className }) => {
  let newUnit = "";
  let result = inspectionResult;
  if (inspectionResult !== "" && unit != null) {
    if (!_.isEmpty(unit)) {
      newUnit = unit.length > 9 ? unit.slice(0, 9) + "..." : unit;
    }
    result += " " + newUnit;
  }
  const title = inspectionResult + unit;
  return (
    <span className={`break-all ${className}`} title={title}>
      {result}
    </span>
  );
};

export default InspectionResultWithUnit;
